import { Alert, Button, Grid, MenuItem, TextField } from '@mui/material'
import { RightSidePanel } from 'wed-components-beta'
import { useServicesService } from './services/useServiceServices'
import { useLookupTables } from '../../hooks/useLookupTables'
import ServicesTable from './services/ServicesTable'
import ServiceSchedules from './scheduledServices/ServicesSchedule'
import ModalAreYouSure from '../assets/ModalAreYouSure'
import ServiceForm from './services/ServiceForm'
import ServicesLastUpdate from './ServicesLastUpdate'
import PreLoader from '../PreLoader'

export default function Services() {

  const {
    lookupTables,
    errorLookupTables,
    isLoadingLookupTables
  } = useLookupTables(['triggers'])

  const {
    isLoading,
    error,
    filteredServices,
    originalTriggers,
    panel,
    setPanel,
    modal,
    setModal,
    filters,
    setFilters,
    isHandlingUpdateOrCreate,
    isHandlingDelete,
    handleDelete,
    handleUpdateOrCreate,
    handleRunService
  } = useServicesService()

  const renderPanel = () => {
    if (panel.panel === 'edit' || panel.panel === 'new') {
      return <ServiceForm
        id={panel.id}
        originalTriggers={originalTriggers}
        handleUpdateOrCreate={handleUpdateOrCreate}
        isHandlingUpdateOrCreate={isHandlingUpdateOrCreate}
      />
    }
    if (panel.panel === 'last-updates') return <ServicesLastUpdate id={panel.id!} />
    if (panel.panel === 'schedules') return <ServiceSchedules id={panel.id!} />
  }

  const getPanelTitle = () => {
    switch (panel.panel) {
      case 'new':
        return 'New Automated Service'
      case 'edit':
        return 'Edit Automated Service'
      case 'last-updates':
        return `Last updates of: ${filteredServices.find((_) => panel.id === _.fk_id_automated_service)?.automated_service_name || 'Unknown'}`
      case 'schedules':
        return `${filteredServices.find((_) => panel.id === _.fk_id_automated_service)?.automated_service_name || 'Unknown'}`
      default:
        return 'New Automated Service'
    }
  }

  if (errorLookupTables) return <Alert severity='error'>Loading lookup tables...</Alert>

  if (isLoadingLookupTables || isLoading) return <PreLoader />

  return (
    <>
      <RightSidePanel
        state={panel.show}
        onClose={() => setPanel({ show: false })}
        title={getPanelTitle() || ''}
      >
        {panel.show && renderPanel()}
      </RightSidePanel>

      {
        modal.show ?
          <ModalAreYouSure
            open={modal.show}
            message='delete this automated service?'
            onCancel={() => setModal({ show: false })}
            onConfirm={() => handleDelete(`${process.env.REACT_APP_NOTIFIER_URL}/automated-services/${modal.id}`)}
            isDisableButton={isHandlingDelete}
          />
          :
          <></>
      }

      <Grid item xs={2}>
        <Button
          variant='contained'
          onClick={() => setPanel({ show: true, panel: 'new' })}
        >
          New Service
        </Button>
      </Grid>

      {/* Spacer */}
      <Grid item xs={5} />
      {/* Filters */}
      <Grid item xs={2}>
        <TextField
          id='search-filter-trigger-name'
          label='Trigger name'
          value={filters.trigger}
          onChange={(e) => setFilters({ ...filters, trigger: Number(e.target.value) })}
          select
        >
          {[
            <MenuItem key={'all'} id="trigger-option-all" value={0}>
              All
            </MenuItem>,
            lookupTables?.triggers.map((_trigger, index) => (
              <MenuItem
                id={`trigger-option-${_trigger.id}`}
                key={index}
                value={_trigger.id}
              >
                {_trigger.trigger_name}
              </MenuItem>
            ))
          ]}
        </TextField>
      </Grid>

      <Grid item xs={3}>
        <TextField
          id='search-filter-service-name'
          label='Service name'
          value={filters.automated_service_name}
          onChange={(e) => setFilters({ ...filters, automated_service_name: e.target.value })}
        />
      </Grid>

      <Grid item xs={12} maxHeight={'70vh'}>
        <ServicesTable
          isLoading={isLoading}
          error={error}
          handleRunService={handleRunService}
          setModal={setModal}
          setPanel={setPanel}
          panel={panel}
          data={filteredServices}
        />
      </Grid>


    </>
  )
}
